import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import ContentPanel from "../ContentPanel/ContentPanel";
import Skeleton from "../Skeleton/Skeleton";

class Booking extends Component {
    componentDidMount() {
    }

    render() {

        return (
                <div>
                    <ContentPanel
                            skeleton={<Skeleton type="MAIN_PANEL"/>}
                            errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                            templateUrl="./content/home/page-components/book/book.html"
                    />
                </div>
        )
    }
}

export default withRouter(connect()(Booking));




// WEBPACK FOOTER //
// ./src/components/Booking/Booking.js